import { endpointWrapper } from './meta.api';

// Alert Config API calls
export const createAlertConfig = (data) =>
    endpointWrapper({
        domain: 'alerts/configs',
        method: 'POST',
        data,
    });

export const fetchAlertConfigs = () =>
    endpointWrapper({
        domain: 'alerts/configs',
        method: 'GET',
    });

export const updateAlertConfig = (alertConfigId, data) =>
    endpointWrapper({
        domain: `alerts/configs/${alertConfigId}`,
        method: 'PUT',
        data,
    });

export const deleteAlertConfig = (alertConfigId) =>
    endpointWrapper({
        domain: `alerts/configs/${alertConfigId}`,
        method: 'DELETE',
    });

// Alert Preview & Tasks
export const generateAlertPreview = (alertConfigId) =>
    endpointWrapper({
        domain: `alerts/configs/${alertConfigId}/preview`,
        method: 'POST',
    });

export const fetchTaskStatus = (taskId) =>
    endpointWrapper({
        domain: `alerts/tasks/${taskId}`,
        method: 'GET',
    });

export const fetchAlertPreview = (taskId) =>
    endpointWrapper({
        domain: `alerts/previews/${taskId}`,
        method: 'GET',
    });

// Alert Sending
export const sendTestAlert = ({ alertPreviewId, sendToAll = false }) =>
    endpointWrapper({
        domain: `alerts/previews/${alertPreviewId}/test`,
        method: 'POST',
        data: { send_to_all: sendToAll },
    });

// Generated Alerts
export const fetchGeneratedAlerts = () =>
    endpointWrapper({
        domain: 'alerts/generated',
        method: 'GET',
    });

// Alert Contexts
export const fetchAlertContexts = () =>
    endpointWrapper({
        domain: 'alerts/contexts',
        method: 'GET',
    });

export const createAlertContext = (data) =>
    endpointWrapper({
        domain: 'alerts/contexts',
        method: 'POST',
        data,
    });

export const updateAlertContext = (alertContextId, data) =>
    endpointWrapper({
        domain: `alerts/contexts/${alertContextId}`,
        method: 'PUT',
        data,
    });

export const deleteAlertContext = (alertContextId) =>
    endpointWrapper({
        domain: `alerts/contexts/${alertContextId}`,
        method: 'DELETE',
    });

export const generateTopicStarter = (data) =>
    endpointWrapper({
        domain: 'alerts/contexts/topic-starter',
        method: 'POST',
        data,
    });

// Categories
export const fetchAlertCategories = (dataSource) =>
    endpointWrapper({
        domain: 'alerts/categories',
        // Scoped to the alert's own source: an alert queries that source's data
        // store, so a category from another taxonomy could never fire.
        params: { data_source: dataSource },
        method: 'GET',
    });
